import { render, staticRenderFns } from "./PhyTestStudents.vue?vue&type=template&id=f975bfee&scoped=true"
import script from "./PhyTestStudents.vue?vue&type=script&lang=js"
export * from "./PhyTestStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f975bfee",
  null
  
)

export default component.exports